import { render, staticRenderFns } from "./SidemenuLayout.vue?vue&type=template&id=c5a51e48&scoped=true&lang=pug&"
import script from "./SidemenuLayout.vue?vue&type=script&lang=ts&"
export * from "./SidemenuLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SidemenuLayout.vue?vue&type=style&index=0&id=c5a51e48&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a51e48",
  null
  
)

export default component.exports